var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 8h50v47h-50z",
    fill: "#0b9fc4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.6 0h34.9v8h-34.9z",
    fill: "#00d563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.6 8h34.9v25.5h-34.9z",
    fill: "#12c6a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelop);
export default __webpack_public_path__ + "static/media/develop.b9476bcaf6dfc3faeafce064371a2dcf.svg";
export { ForwardRef as ReactComponent };